<template>
  <div>
    <el-row>
      <el-col>
        <el-card>
          <el-select
            v-model="classId"
            placeholder="请选择班级"
            @click="onClickClass"
          >
            <el-option
              v-for="item in classList"
              :key="item.Id"
              :label="item.GradeNameAndClassName"
              :value="item.Id"
            >
            </el-option>
          </el-select>
          <el-date-picker
            style="margin-left: 0.25rem"
            v-model="value1"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-card>
      </el-col>
    </el-row>
    <el-row style="margin-top: 0.25rem" class="flex">
      <el-col :span="12">
        <el-card>
          <div slot="header" class="tui-cardTitle">
            <span>幼儿考勤</span>
          </div>
          <div class="tui-right">
            <div
              class="tui-rightItem"
              style="width: calc(100% / 5); margin: 0"
              v-for="(item, index) in childrenList"
              :key="index"
            >
              <div class="flex-items tui-rightItemBox" style="padding: 0">
                <p class="tui-Num">{{ item.count }}</p>
                <p class="tui-desc">{{ item.title }}</p>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12" style="margin-left: 0.25rem">
        <el-card>
          <div slot="header" class="tui-cardTitle">
            <span>教师考勤</span>
          </div>
          <div class="tui-right">
            <div
              class="tui-rightItem"
              style="width: calc(100% / 5); margin: 0"
              v-for="(item, index) in teacherList"
              :key="index"
            >
              <div class="flex-items tui-rightItemBox" style="padding: 0">
                <p class="tui-Num">{{ item.count }}</p>
                <p class="tui-desc">{{ item.title }}</p>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="flex" style="margin-top: 0.25rem">
      <el-col :span="12" class="flex">
        <el-card style="flex: 1">
          <div slot="header" class="tui-cardTitle">
            <span>幼儿云盘</span>
          </div>
          <div class="tui-right">
            <div
              class="tui-rightItem"
              style="width: calc(100% / 3); margin: 0"
              v-for="(item, index) in ChildTray"
              :key="index"
            >
              <div class="flex-items tui-rightItemBox" style="padding: 0">
                <p class="tui-Num">{{ item.count }}</p>
                <p class="tui-desc">{{ item.title }}</p>
              </div>
            </div>
          </div>
        </el-card>
        <el-card style="flex: 1; margin-left: 0.25rem">
          <div slot="header" class="tui-cardTitle">
            <span>教师云盘</span>
          </div>
          <div class="tui-right">
            <div
              class="tui-rightItem"
              style="width: calc(100% / 3); margin: 0"
              v-for="(item, index) in teacherTray"
              :key="index"
            >
              <div class="flex-items tui-rightItemBox" style="padding: 0">
                <p class="tui-Num">{{ item.count }}</p>
                <p class="tui-desc">{{ item.title }}</p>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12" class="flex" style="margin-left: 0.25rem">
        <el-card
          style="flex: 1"
          v-for="(item, index) in messageList"
          :key="index"
          :style="{ 'margin-left': index == 1 ? '0.25rem' : '' }"
        >
          <div slot="header" class="tui-cardTitle">
            <span>{{ item.Name }}</span>
          </div>
          <div class="tui-right">
            <div class="tui-rightItem" style="width: calc(100% / 2); margin: 0">
              <div class="flex-items tui-rightItemBox" style="padding: 0">
                <p class="tui-Num">
                  {{ item.SendInfo == "NaN%" ? "0%" : item.SendInfo }}
                </p>
                <p class="tui-desc">已发布</p>
              </div>
            </div>
            <div class="tui-rightItem" style="width: calc(100% / 2); margin: 0">
              <div class="flex-items tui-rightItemBox" style="padding: 0">
                <p class="tui-Num">
                  {{ item.LookInfo == "NaN%" ? "0%" : item.LookInfo }}
                </p>
                <p class="tui-desc">查看率</p>
              </div>
            </div>
          </div>
        </el-card>
        <!-- <el-card style="flex: 1; margin-left: 0.25rem">
          <div slot="header" class="tui-cardTitle">
            <span>问卷调查</span>
          </div>
          <div class="tui-right">
            <div
              class="tui-rightItem"
              style="width: calc(100% / 2); margin: 0"
              v-for="(item, index) in 2"
              :key="index"
            >
              <div class="flex-items tui-rightItemBox" style="padding: 0">
                <p class="tui-Num">123</p>
                <p class="tui-desc">标题</p>
              </div>
            </div>
          </div>
        </el-card> -->
      </el-col>
    </el-row>

    <el-row class="flex" style="margin-top: 0.25rem">
      <el-col :span="12" class="flex">
        <el-card style="flex: 1">
          <div slot="header" class="tui-cardTitle">
            <span>{{ CircleList.Name }}</span>
          </div>
          <div class="tui-right">
            <div class="tui-rightItem" style="width: calc(100% / 2); margin: 0">
              <div class="flex-items tui-rightItemBox" style="padding: 0">
                <p class="tui-Num">{{ CircleList.SendInfo }}</p>
                <p class="tui-desc">今日发布</p>
              </div>
            </div>
            <div class="tui-rightItem" style="width: calc(100% / 2); margin: 0">
              <div class="flex-items tui-rightItemBox" style="padding: 0">
                <p class="tui-Num">{{ CircleList.LookInfo }}</p>
                <p class="tui-desc">今日上传照片</p>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12" class="flex" style="margin-left: 0.25rem">
        <el-card style="flex: 1">
          <div slot="header" class="tui-cardTitle">
            <span>安全预警</span>
          </div>
          <div class="tui-right">
            <div
              class="tui-rightItem"
              style="width: calc(100% / 1); margin: 0"
              v-for="(item, index) in 1"
              :key="index"
            >
              <div class="flex-items tui-rightItemBox" style="padding: 0">
                <p class="tui-Num">{{ SecurityList }}</p>
                <p class="tui-desc">今日安全预警</p>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  GetIndex_Home_MessageInfo,
  GetTeacherClassRoleInfo,
  GetIndex_Home_ClassCircleInfo,
  GetIndex_Home_SecurityInfo,
  GetWebStudentAttendStatis,
  GetTeacherAttendStatis,
  GetSchoolCloudDiskInfo,
} from "../../api/api";

export default {
  data() {
    return {
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      value: "",
      value1: "",
      classList: [],
      classId: null,
      messageList: [],
      CircleList: {},
      SecurityList: "",
      childrenList: [],
      teacherList: [],
      ChildTray: [],
      teacherTray: [],
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    await this.GetTeacherClassRoleInfo();
    await this.GetIndex_Home_MessageInfo();
    await this.GetIndex_Home_ClassCircleInfo();
    await this.GetIndex_Home_SecurityInfo();
    await this.GetWebStudentAttendStatis();
    await this.GetTeacherAttendStatis();
    await this.GetSchoolCloudDiskInfo();
  },
  methods: {
    onClickClass(e) {
      this.classId = e;
      this.GetIndex_Home_MessageInfo();
      this.GetIndex_Home_ClassCircleInfo();
      this.GetIndex_Home_SecurityInfo();
      this.GetWebStudentAttendStatis();
      this.GetTeacherAttendStatis();
      this.GetSchoolCloudDiskInfo();
    },
    async GetSchoolCloudDiskInfo() {
      let res = await GetSchoolCloudDiskInfo({
        Id: this.classId,
        Time: this.value1,
      });
      if (res.data.success) {
        this.ChildTray = [
          {
            title: "照片",
            count: res.data.response.PictureNum,
          },
          {
            title: "视频",
            count: res.data.response.VideoNum,
          },
          {
            title: "报告",
            count: res.data.response.ReportNum,
          },
        ];
        this.teacherTray = [
          {
            title: "课件",
            count: res.data.response.CoursewareNum,
          },
          {
            title: "共享文件",
            count: res.data.response.ShareFileNum,
          },
          {
            title: "个人文件",
            count: res.data.response.FileNum,
          },
        ];
      }
    },
    // 教师考勤
    async GetTeacherAttendStatis() {
      let res = await GetTeacherAttendStatis({
        Id: this.classId,
        Time: this.value1,
      });
      if (res.data.success) {
        this.teacherList = [
          {
            title: "请假人数",
            count: res.data.response.LeaveNum,
          },
          {
            title: "应到人数",
            count: res.data.response.TotalNum,
          },
          {
            title: "打卡人数",
            count: res.data.response.ClockNum,
          },
          {
            title: "出勤率",
            count: res.data.response.Attendance,
          },
          {
            title: "缺勤数",
            count: res.data.response.AbsenceDutyNum,
          },
        ];
      }
    },
    async GetWebStudentAttendStatis() {
      let res = await GetWebStudentAttendStatis({
        Id: this.classId,
        Time: this.value1,
      });
      if (res.data.success) {
        this.childrenList = [
          {
            title: "请假人数",
            count: res.data.response.LeaveNum,
          },
          {
            title: "应到人数",
            count: res.data.response.TotalNum,
          },
          {
            title: "打卡人数",
            count: res.data.response.ClockNum,
          },
          {
            title: "出勤率",
            count: res.data.response.Attendance,
          },
          {
            title: "缺勤数",
            count: res.data.response.AbsenceDutyNum,
          },
        ];
        // this.SecurityList = res.data.response;
      }
    },
    async GetIndex_Home_SecurityInfo() {
      let res = await GetIndex_Home_SecurityInfo({
        Id: this.classId,
        Time: this.value1,
      });
      if (res.data.success) {
        this.SecurityList = res.data.response;
      }
    },
    async GetIndex_Home_ClassCircleInfo() {
      let res = await GetIndex_Home_ClassCircleInfo({
        Id: this.classId,
        Time: this.value1,
      });
      if (res.data.success) {
        this.CircleList = res.data.response;
      }
    },
    async GetIndex_Home_MessageInfo() {
      let res = await GetIndex_Home_MessageInfo({
        Id: this.classId,
        Time: this.value1,
      });
      if (res.data.success) {
        this.messageList = res.data.response;
      }
    },
    // 获取幼儿下拉数据
    async GetTeacherClassRoleInfo() {
      let xhr = await GetTeacherClassRoleInfo();
      let themeArr = [];
      let classArr = [];
      if (this.userInfo.UserIdentity == "1") {
        classArr.push({
          GradeNameAndClassName: "全园",
          ClassName: "全园",
          GradeName: "全园",
          Id: 0,
        });
      }
      xhr.data.response.forEach((Gradeitem) => {
        Gradeitem.ClassInfo.forEach((classItem) => {
          classArr.push({
            GradeNameAndClassName:
              Gradeitem.GradeName + (classItem.Name ? classItem.Name : ""),
            ClassName: classItem.Name ? classItem.Name : "",
            Id: classItem.Id,
            ...Gradeitem,
          });
        });
      });

      this.classList = classArr;
      this.classId = this.classList[0].Id;
    },
  },
};
</script>
<style lang="less" scoped>
.tui-cardTitle {
  font-size: 0.275rem;
  font-weight: 600;
  color: #333;
}
.tui-right {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  .tui-rightItem {
    width: calc(100% / 5);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0.625rem;
    img {
      width: 0.825rem;
      height: 0.825rem;
    }
    .tui-rightItemBox {
      flex-direction: column;
      padding-left: 0.325rem;
      .tui-Num {
        font-size: 0.4rem;
        font-weight: 500;
        color: #333;
      }
      .tui-desc {
        font-size: 0.15rem;
        font-weight: 500;
        color: #333;
        // padding-top: 0.175rem;
      }
    }
  }
}
</style>